module.exports = __webpack_public_path__ + "static/zhaoyaoxingjilu-a053636b5dbfd548238a10f0fe0ef423.jpeg";